export const borderRadius = {
  sm: '4px',
  md: '8px',
  lg: '16px',
} as const;
